import React, { useState, useEffect } from 'react';
import { Container, Nav, Tab, Spinner } from 'react-bootstrap';
import SubscriptionSecurityTab from './SubscriptionSecurityTab';
import PaymentMethodsTab from './PaymentMethodsTab';
import PaymentHistoryTab from './PaymentHistoryTab';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from 'axios';
import apiConfig from '../credentials/apiConfig';
import './styles.scss';
import STRIPE_PUBLIC_KEY from '../../stripeConfig';
import Loader from '../../components/Loader';


const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const Settings = () => {
  const [activeTab, setActiveTab] = useState('subscription');
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      const userId = localStorage.getItem('userId');
      if (!userId) return;

      try {
        const response = await axios.get(`${apiConfig.apiBaseURL}/getUserProfile/${userId}`, {
          headers: {
            "x-api-key": apiConfig["x-api-key"],
            "Content-Type": "application/json"
          }
        });

        if (response.data.success) {
          setUserData(response.data.user);
        }
      } catch (error) {
        console.error("Failed to fetch user profile", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  const mockPaymentHistory = userData?.subscriptionHistory?.map((entry) => ({
    id: entry.stripeTransactionId,
    status: entry.stripeSubscriptionStatus === "active" ? "success" : "failed",
    amount: entry.amountPaid || 0,
    plan: "Professional Plan – Monthly",
    cardType: userData.paymentMethods?.find(
      method => method.methodId === entry.stripePaymentMethodId
    )?.brand || "N/A",
    last4: userData.paymentMethods?.find(
      method => method.methodId === entry.stripePaymentMethodId
    )?.last4 || "****",
    date: new Date(entry.currentPeriodStart).toLocaleDateString()
  })) || [];
  


  return (
    <div>
      <p className="text-light mb-4 bg-white w-100 shadow-sm p-3">
        Manage your subscription, payment methods and view transaction history
      </p>

      <Container fluid className="mt-2 mb-5 settings-page">
        {loading ? (
          <div className="text-center mt-5">
            <Loader/>
          </div>
        ) : (
          <Elements stripe={stripePromise}>
            <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
              <Nav variant="tabs" className="mb-4">
                <Nav.Item>
                  <Nav.Link eventKey="subscription">Subscription & Security</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="payment-methods">Payment Methods</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="payment-history">Payment History</Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="subscription">
                  <SubscriptionSecurityTab user={userData} />
                </Tab.Pane>
                <Tab.Pane eventKey="payment-methods">
                  <PaymentMethodsTab user={userData} />
                </Tab.Pane>
                <Tab.Pane eventKey="payment-history">
                <PaymentHistoryTab paymentHistory={mockPaymentHistory} />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Elements>
        )}
      </Container>
    </div>
  );
};

export default Settings;